import React from 'react';
import { useSelector } from 'react-redux';
import { keyframes, styled } from 'styled-components';
import THEME from '../../theme.js';
const round = (num) => Math.round(num * 100) / 100;
const CreditScore = (props) => {
    const { score, paymentRatio } = props;
    const lang = useSelector((s) => s.lang);
    const paid = !Number.isNaN(paymentRatio) ? paymentRatio : 0;
    const fullyPaid = paid >= 1;
    const restScore = score - paid;
    const scorePercentage = restScore > 0 ? Math.round(restScore * 100) : 0;
    return (React.createElement(Wrapper, null,
        React.createElement(Slider, { "data-tooltip-content": fullyPaid
                ? null
                : `${lang.creditScore.estimated} ${round(scorePercentage)}% ${paid === 0
                    ? lang.creditScore.estimateZero
                    : lang.creditScore.estimate}`, "data-tooltip-id": "tooltip-top" },
            React.createElement(Score, { score: fullyPaid ? 100 : scorePercentage })),
        React.createElement(Percentages, null,
            React.createElement("span", null, "0%"),
            React.createElement("span", null, fullyPaid ? lang.creditScore.paid : null),
            React.createElement("span", null, "100%"))));
};
const fadeIn = keyframes `
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const Wrapper = styled.div `
  width: 100%;
  height: 100%;
`;
const Slider = styled.div `
  animation-name: ${fadeIn};
  animation-timing-function: ease;
  animation-duration: 200ms;
  background: ${THEME.FILL};
  width: 100%;
  height: 32px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;
const Score = styled.div `
  width: 100%;
  clip-path: inset(0 ${(props) => 100 - props.score}% 0 0);
  background: linear-gradient(90deg, #7864ff, #230a58);
  position: absolute;
  height: 32px;
  top: 0;
  left: 0;
`;
const Percentages = styled.div `
  animation-name: ${fadeIn};
  animation-timing-function: ease;
  animation-duration: 200ms;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.7em;
  padding: 0.5em 0;
  position: relative;
`;
export default CreditScore;
//# sourceMappingURL=CreditScore.js.map